import React from "react";
import { Spinner } from "react-bootstrap";
import ImageProfileUploader from "../../Components/ImageProfileUploader";
import { useProfile } from "./Hooks";
import DatePicker, {
  Calendar,
  getAllDatesInRange,
} from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { ConvertDate, ToDateJalali } from "../../Utils/functions";
const Profile = () => {
  const { loading, user, submit, handler, updateImageProfile } = useProfile();
  return (
    <div>
      <div className="card mb-3 profile">
        {/* <div className="card-header">
          <h5 className="mb-0">تنظیمات پروفایل</h5>
        </div> */}
        <div className="card-body bg-light">
          <div className="row justify-content-center">
            <div className="col-3">
              <ImageProfileUploader
                preview={user?.user?.photo && user?.user?.photo[0]}
                onChange={files => {
                  updateImageProfile(files[0]);
                }}
                loading={loading.imageProfile}
              />
            </div>
          </div>
          <div className="row g-3">
            <div className="col-lg-6">
              {" "}
              <label className="form-label" htmlFor="first-name">
                نام و نام خانوادگی
              </label>
              <input
                className="form-control"
                id="first-name"
                type="text"
                defaultValue={user?.user?.fullname}
                onChange={({ target: { value } }) => {
                  handler("fullname", value);
                }}
              />
            </div>

            <div className="col-lg-6">
              {" "}
              <label className="form-label" htmlFor="email1">
                موبایل
              </label>
              <input
                className="form-control"
                id="number"
                disabled={true}
                type="text"
                defaultValue={user?.user?.mobile}
              />
            </div>
            <div className="col-lg-6">
              {" "}
              <label className="form-label" htmlFor="email2">
                ایمیل
              </label>
              <input
                className="form-control"
                id="email2"
                type="email"
                defaultValue={user?.user?.email}
                onChange={({ target: { value } }) => {
                  handler("email", value);
                }}
              />
            </div>
            <div className="col-lg-6">
              {" "}
              <label className="form-label" htmlFor="email2">
                جنسیت
              </label>
              <select
                className="form-control"
                id="email2"
                type="text"
                defaultValue={user?.user?.sex}
                onChange={({ target: { value } }) => {
                  handler("sex", value);
                }}
              >
                <option>انتخاب کنید</option>
                <option value={"male"}>آقا</option>
                <option value={"female"}>خانم</option>
              </select>
            </div>
            <div className="col-lg-6">
              <div className="col-md-4 mt-2">
                <label className="form-label" htmlFor="email2">
                  تاریخ تولد
                </label>
                <Calendar
                  onChange={data => {
                    handler(
                      "br_day",
                      ConvertDate(
                        `${data.year}/${data.month.number}/${data.day}`
                      )
                    );
                  }}
                  calendar={persian}
                  locale={persian_fa}
                  format="MM/DD/YYYY"
                  // value="05/18/2020"
                  // value={ToDateJalali(user?.user?.br_day)}
                />
              </div>
            </div>
            <div className="col-12 d-flex justify-content-end">
              <button className="btn btn-primary" onClick={submit}>
                {loading.edit ? <Spinner /> : "به روز رسانی"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
